import { useQuery } from '@tanstack/react-query';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { MarginInfo } from 'src/stores/velocityStoreTypes';
import { useWarnIfProviderMissing } from './useWarnIfProviderMissing';
import {
	accountTradingDataQueryKeys,
	GC_TIME_MS,
} from './accountTradingDataQueryKeys';
import { MarginInfoByUserKey } from './utils/types';

export function useMarginInfoByUserKey(userKey: string | undefined) {
	useWarnIfProviderMissing('useMarginInfoByUserKey');

	return useQuery<MarginInfoByUserKey, unknown, MarginInfo | undefined>({
		queryKey: accountTradingDataQueryKeys.marginInfo(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
		select: (data) => (userKey ? data?.[userKey] : undefined),
	});
}

export function useCurrentAccountMarginInfo(): MarginInfo | undefined {
	const userKey = useVelocityAccountStore((s) => s.currentUserKey);
	return useMarginInfoByUserKey(userKey).data;
}

export function useAllAccountsMarginInfo() {
	useWarnIfProviderMissing('useAllAccountsMarginInfo');

	return useQuery<MarginInfoByUserKey>({
		queryKey: accountTradingDataQueryKeys.marginInfo(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
	});
}
